// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3J7Z3","log":"ModalInventoryLogs_log__3Znk8","date":"ModalInventoryLogs_date__3Jjl9","userName":"ModalInventoryLogs_userName__3NihY"};